module.exports = __webpack_public_path__ + "img/elementlengths_jak.5fe312e4.png";